import { createAsyncThunk } from "@reduxjs/toolkit";
import { UploadKYCDoc } from "../../apis/uploadKYC";
import { UploadKYCDocFgn } from "../../apis/uploadKYCFgn";

export const UploadKYCFgn = createAsyncThunk("uploadKYC", async () => {
  const response = await UploadKYCDocFgn();
  // console.warn("second action res-->", response);
});
